import { render } from "./AccountSecurity.vue?vue&type=template&id=60ad6a24&scoped=true"
import script from "./AccountSecurity.vue?vue&type=script&lang=js"
export * from "./AccountSecurity.vue?vue&type=script&lang=js"

import "./AccountSecurity.vue?vue&type=style&index=0&id=60ad6a24&scoped=true&lang=css"

import exportComponent from "/root/.jenkins/workspace/WJ-WEB/htweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60ad6a24"]])

export default __exports__